<template>
  <div class='index_con'>
    <div class='pub_top_block w_1200 index_pub_top_block'>
      <dl>
        <dt>
          <h3>{{ $t('home.slogan.title.text') }}</h3>
          <div class='text' v-html='$t("home.slogan.desc")'>
          </div>
        </dt>
        <dd>
          <router-link to='/goods' class='more more2'>{{ $t('home.slogan.button') }}</router-link>
        </dd>
      </dl>
      <img src='@/assets/icons/ill_lookbook@2x.png' alt='' class='bg index_banner' width='666' height='530'>
    </div>
    <div id='block2' class='block2 w_1200'>
      <div class='pub_tit dream' data-animate='fadeInUp,1s,linear'>{{ $t('home.advantages.title') }}</div>
      <ul class='fz_0 dream' data-animate='fadeInUp,1s,linear'>
        <li v-for='(item, index) in advantageList' :key='index'>
          <div class='img_box'><img :src='item.image' alt=''></div>
          <h3>{{ item.title }}</h3>
          <div class='text'>{{ item.desc }}</div>
        </li>
      </ul>
      <router-link to='/goods' class='more'>{{ $t('home.advantages.button') }}</router-link>
    </div>
    <div class='block3'>
      <div class='w_1200'>
        <div class='pub_tit dream' data-animate='fadeInUp,1s,linear'>{{ $t('home.products.title') }}</div>
        <block-products :media-device='mediaDevice'></block-products>
      </div>
    </div>
    <div class='block4 w_1200'>
      <div class='pub_tit dream' data-animate='fadeInUp,1s,linear'>{{ $t('home.experts.info.title') }}</div>
      <block-famous :media-device='mediaDevice'></block-famous>
      <router-link to='/bigshot'><a href='#' class='more more2'>{{ $t('home.experts.info.more') }}</a></router-link>
    </div>
    <div class='block5'>
      <div class='w_1200'>
        <div class='pub_tit dream' data-animate='fadeInUp,1s,linear'>{{ $t('home.channel.info.title') }}</div>
        <ul class='fz_0 text_center dream' data-animate='fadeInUp,1s,linear'>
          <li class='img_box'><img src='@/assets/icons/ic_logo_jd@2x.png' alt=''></li>
          <li class='img_box'><img src='@/assets/icons/ic_logo_tianmao@2x.png' alt=''></li>
          <li class='img_box'><img src='@/assets/icons/ic_logo_dd@2x.png' alt=''></li>
          <li></li><!-- 占位 -->
        </ul>
        <router-link to='/cooperate'><a href='#' class='more more2'>{{ $t('home.channel.info.more') }}</a></router-link>
      </div>
    </div>
    <div class='block6'>
      <div class='w_1200'>
        <div class='pub_tit dream' data-animate='fadeInUp,1s,linear'>{{ $t('home.partners.title') }}</div>
        <ul class='fz_0 text_left dream' data-animate='fadeInUp,1s,linear'>
          <li class='img_box'><img src='@/assets/icons/ic_logo_penguin@2x.png' alt=''></li>
          <li class='img_box'><img src='@/assets/icons/ic_logo_harper@2x.png' alt=''></li>
          <li class='img_box'><img src='@/assets/icons/ic_logo_oxford@2x.png' alt=''></li>
          <li class='img_box'><img src='@/assets/icons/ic_logo_scholastic@2x.png' alt=''></li>
          <li class='img_box'><img src='@/assets/icons/ic_logo_walker@2x.png' alt=''></li>
          <li class='img_box'><img src='@/assets/icons/ic_logo_childsplay@2x.png' alt=''></li>
          <li class='img_box'><img src='@/assets/icons/ic_logo_highlights@2x.png' alt=''></li>
          <li class='img_box'><img src='@/assets/icons/ic_logo_moonlight@2x.png' alt=''></li>
          <li class='img_box'><img src='@/assets/icons/ic_logo_blcup@2x.png' alt=''></li>
          <li class='img_box'><img src='@/assets/icons/ic_logo_cengage@2x.png' alt=''></li>
          <li class='img_box'><img src='@/assets/icons/ic_logo_free@2x.png' alt=''></li>
          <li class='img_box'><img src='@/assets/icons/ic_logo_benchmark@2x.png' alt=''></li>
          <li class='img_box'><img src='@/assets/icons/ic_logo_win@2x.png' alt=''></li>
          <li></li><!-- 占位 -->
        </ul>
      </div>
    </div>
    <div class='block7'>
      <div class='w_1200'>
        <div class='pub_tit'>{{ $t('home.qa.info.title') }}</div>
        <div class='block7_con'>
          <div class='img_box dis_ib ver_m'>
            <video :src='lastestQa.video' controls='controls' :poster='lastestQa.image' style='width: 100%;height: 100%;'></video>
          </div>
          <div class='dis_ib ver_m more_btn fz_0'>
            <router-link to='/qa'>
              <span>{{ $t('home.qa.info.more') }}</span><i class='enter_btn'></i>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- 子底部模块 -->
    <pub-bottom />
  </div>
</template>

<script>
import { setTitle, mediaDevice } from 'utils'
import { getLastestQa } from '@/service'
import BlockProducts from '@/components/BlockProducts'
import BlockFamous from '@/components/BlockFamous'
import PubBottom from '@/components/PubBottom'
import { listHandler } from '@/utils/variable'

export default {
  name: 'Home',
  data () {
    return {
      lastestQa: {}, // 最近QA
      mediaDevice: mediaDevice(),
    }
  },
  components: {
    BlockProducts,
    BlockFamous,
    PubBottom,
  },
  computed: {
    advantageList () {
      let list = [
        {
          image: require(`@/assets/icons/ic_variety@2x.png`),
        }, {
          image: require(`@/assets/icons/ic_geniune@2x.png`),
        }, {
          image: require(`@/assets/icons/ic_bookselection@2x.png`),
        }, {
          image: require(`@/assets/icons/ic_price@2x.png`),
        },
      ]
      // 结合语言版本进行初始化数据
      return listHandler.call(this, list, 'home.advantages.list')
    },
  },
  methods: {
    initData () {
    },
    initAnimation () {
      // 获取浏览器可见区域高度
      var windowHeight = document.documentElement.clientHeight
      // 用户手动修改浏览器可见区域高度时修改变量
      window.addEventListener('resize', () => {
        this.mediaDevice = mediaDevice()
      })
      // 获取所需效果元素
      var myDream = document.getElementsByClassName('dream')
      // 鼠标滚轮滚动执行方法
      window.onscroll = function () {
        // 获取鼠标滚轮滚动距离
        var _scrollTop = document.body.scrollTop || document.documentElement.scrollTop

        // 循环类dream
        for (var k = 0; k < myDream.length; k++) {
          if (_scrollTop >= getOffsetTop(myDream[k]) - windowHeight && _scrollTop <= getOffsetTop(myDream[k])) {
            myDream[k].style.animationName = myDream[k].dataset.animate.split(',')[0]
            myDream[k].style.animationDuration = myDream[k].dataset.animate.split(',')[1]
            myDream[k].style.animationTimingFunction = myDream[k].dataset.animate.split(',')[2]
          }
        }
      }

      // // 判断元素父集是否有已定位元素
      function getOffsetTop (ele) {
        var rtn = ele.offsetTop
        var o = ele.offsetParent
        while (o != null) {
          rtn += o.offsetTop
          o = o.offsetParent
        }
        return rtn
      }

      // 滚动条等于0时执行第一屏效果
      function myAnimation () {
        var _scrollTop = document.body.scrollTop || document.documentElement.scrollTop
        // 效果方法
        for (var k = 0; k < myDream.length; k++) {
          if (_scrollTop >= getOffsetTop(myDream[k]) - windowHeight && _scrollTop <= getOffsetTop(myDream[k])) {
            myDream[k].style.animationName = myDream[k].dataset.animate.split(',')[0]
            myDream[k].style.animationDuration = myDream[k].dataset.animate.split(',')[1]
            myDream[k].style.animationTimingFunction = myDream[k].dataset.animate.split(',')[2]
          }
        }
      }
      myAnimation()
    },
  },
  beforeMount () {
    setTitle(`${this.$t('home.logo')} - ${this.$t('home.title')}`)
  },
  mounted () {
    this.initData()
    getLastestQa().then(res => {
      this.lastestQa = res.data
    })
    this.initAnimation()
  },
}
</script>
